// Helper function to process text and render with bold parts
export const renderBoldText = (item) => {
  // Return early if item is not a string or is empty
  if (!item || typeof item !== 'string') {
    return item;
  }

  try {
    // Split the string by semicolons first (treating them as line breaks)
    const lines = item.split(";");

    return lines.flatMap((line, lineIdx) => {
      // Split by bold markers within each line
      const parts = line.split(/(\*\*.*?\*\*)/);

      const formattedLine = parts.map((part, partIdx) =>
        part.startsWith("**") && part.endsWith("**") ? (
          <strong key={`bold-${lineIdx}-${partIdx}`}>{part.slice(2, -2)}</strong>
        ) : (
          part
        )
      );

      // Add a line break only if it's not the last line
      return lineIdx < lines.length - 1
        ? [...formattedLine, <br key={`br-${lineIdx}`} />]
        : formattedLine;
    });
  } catch (error) {
    return item;
  }
};



export const renderBoldTextHash = (item) => {
  // Return early if item is not a string or is empty
  if (!item || typeof item !== 'string') {
    return item;
  }

  try {
    // Remove ### prefix if present
    const cleanedItem = item.startsWith('###') ? item.slice(3).trim() : item;
    
    const parts = cleanedItem.split(/(\*\*.*?\*\*)/); // Split string by bold markers
    
    // If no bold markers found, return cleaned text
    if (parts.length === 1) {
      return cleanedItem;
    }

    return parts.map((part, idx) => {
      if (part.startsWith("**") && part.endsWith("**")) {
        const boldText = part.slice(2, -2);
        // Only render as bold if there's text between markers
        return boldText ? <strong key={idx}>{boldText}</strong> : part;
      }
      return part; // Render normal text
    });
  } catch (error) {
    // If any error occurs during processing, return original text
    return item;
  }
}

export const formatCurrency = (value) => {
  if (value == 0 || value == 0.0) return '0.0';
  if (!value) return '...';
  
  const num = parseFloat(value);
  if (isNaN(num)) return '...';

  // Handle billions and millions
  if (num >= 1000000000) {
    const billions = (num / 1000000000).toFixed(2);
    return `${billions.replace(/\B(?=(\d{3})+(?!\d))/g, '.')}Bn`;
  }
  
  if (num >= 1000000) {
    const millions = (num / 1000000).toFixed(2);
    return `${millions.replace(/\B(?=(\d{3})+(?!\d))/g, '.')}Mn`;
  }

  // For smaller numbers, format with dots and commas
  const numStr = num.toFixed(2);
  const [whole, decimal] = numStr.split('.');
  const formattedWhole = whole.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  return `${formattedWhole},${decimal}`;
};

export const formatDateForInput = (dateTimeStr) => {
  //return dateTimeStr;
  if (!dateTimeStr) return "";

  try {
    // Extract components from the input string
    let [dayPart, month, year, time, period, tz] = dateTimeStr.split(/[\s,]+/);

    // Remove ordinal suffix from the day (e.g., "6th" → "6")
    let day = dayPart.replace(/\D/g, ""); 

    // Convert month name to number
    const months = {
      January: "01",
      February: "02",
      March: "03",
      April: "04",
      May: "05",
      June: "06",
      July: "07",
      August: "08",
      September: "09",
      October: "10",
      November: "11",
      December: "12",
    };

    let monthNum = months[month];
    if (!monthNum) return "";

    // Convert 12-hour format to 24-hour format
    let [hour, minute] = time.split(":");
    hour = parseInt(hour, 10);

    if (period === "PM" && hour !== 12) {
      hour += 12;
    } else if (period === "AM" && hour === 12) {
      hour = 0;
    }

    // Format the values to match "YYYY-MM-DDTHH:mm"
    let formattedDate = `${year}-${monthNum}-${day.padStart(2, "0")}T${hour
      .toString()
      .padStart(2, "0")}:${minute}`;

    return formattedDate;
  } catch (error) {
    console.error("Error formatting date:", error);
    return "";
  }
};
